import React, { useEffect, useMemo, useState } from "react"
import { Table, Row, Col, Card, CardBody, Form, Modal } from "reactstrap"
import { useTable, useGlobalFilter, usePagination } from "react-table"
import { Link, Navigate, useNavigate } from "react-router-dom"
import Select from "react-select"
// css
import "../../../assets/css/Settings/Setting.css"
import "../../../assets/css/Marketing/Marketing.css"

// commom
import Pagination from "components/Common/Pagination"

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import configure from "configure"
import { set } from "lodash"
import {
    colourStyles,
    locationOptions,
    status_options,
    TenderStatus,
} from "utils/common-options"
import axios from "axios"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"
import { BiddingColumns } from "utils/columns/Marketing/TenderCols"
import { useSelector } from "react-redux"
import secureLocalStorage from "react-secure-storage"

function TableContainer({
    columns,
    data,
    setLoading,
    refreshData,
    sourceId
}) {
    const [fixedContent, setFixedContent] = useState(false)

    const [addTenderModal, setAddTenderModal] = useState(false)

    const navigate = useNavigate()

    document.addEventListener("scroll", () => {
        if (window.scrollY > 160) {
            setFixedContent(true)
        } else {
            setFixedContent(false)
        }
    })

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        state,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        gotoPage,
        setPageSize,
        pageOptions,
        setGlobalFilter,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        usePagination
    )

    const { pageIndex, pageSize, globalFilter } = state

    // Render the UI for your table
    return (
        <div>
            <Row className="mb-2">
                <Col>
                    <select
                        className="border-radius form-select"
                        style={{ width: "100px" }}
                        value={pageSize}
                        onChange={e => setPageSize(e.target.value)}
                    >
                        {[10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </Col>
                <Col md={10} className="d-flex justify-content-end">
                    <div className="me-4">
                        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                            <div className="position-relative">
                                <label htmlFor="search-bar-0" className="search-label">
                                    <span id="search-bar-0-label" className="sr-only">
                                        Search this table
                                    </span>
                                    <input
                                        onChange={e => setGlobalFilter(e.target.value)}
                                        id="search-bar-0"
                                        type="text"
                                        className="border-radius form-control rounded h-100"
                                        placeholder={` Search...`}
                                        value={globalFilter || ""}
                                    />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Link
                            to={`${configure.appUrl}marketing/add-bidding/${sourceId}`}
                            className="border-radius btn btn-purple me-2"
                        >
                            <i className="fas fa-plus me-2 icon-size"></i>Bidding
                        </Link>
                    </div>
                </Col>
            </Row>

            <div className="position-relative">
                <Table className="table table-bordered mt-3" {...getTableProps()}>
                    <thead
                        className={`${fixedContent ? "fixed-setting-header" : ""
                            } fix-Tender-header`}
                    >
                        {headerGroups.map((headerGroup, i) => (
                            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, index) => (
                                    <th
                                        key={index}
                                        className={`t-col-${index + 1} ${column.className}`}
                                        {...column.getHeaderProps()}
                                    >
                                        {column.render("Header")}
                                        {column.isInfoIcon ? (
                                            <i
                                                title="info"
                                                className="bx bx-info-circle ms-1 info-icon"
                                            ></i>
                                        ) : null}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody className="fix-Tender-header" {...getTableBodyProps()}>
                        {page.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr className="row-hover" {...row.getRowProps()} key={i}>
                                    {row.cells.map((cell, index) => {
                                        return (
                                            <td
                                                key={index}
                                                className={`t-col-${index + 1} ${cell.column.className
                                                    }`}
                                                {...cell.getCellProps()}
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>

            {/* Pagination */}
            <Row className="justify-content-md-end justify-content-center align-items-center">
                <Pagination
                    gotoPage={gotoPage}
                    previousPage={previousPage}
                    canPreviousPage={canPreviousPage}
                    nextPage={nextPage}
                    canNextPage={canNextPage}
                    pageIndex={pageIndex}
                    pageOptions={pageOptions}
                />
            </Row>


        </div>
    )
}

const Bidding = ({ verticalActiveTab }) => {
    const [isLoading, setLoading] = useState(false)
    const [tenderData, setTenderData] = useState([])

    const fetchData = async () => {
        const user_id = localStorage.getItem("auth_id")
        const response = await fetchNodeData(
            setLoading,
            `bidding/getbiddings/${user_id}/${verticalActiveTab}`,
            secureLocalStorage.getItem("auth_token")
        )
        if (response?.status === 200) {
            const dataWithMappedField = response.data.map(item => ({
                ...item,
                aboutTender: item.description,
            }))
            setTenderData(dataWithMappedField)
        } else {
            setTenderData([])
        }
    }

    useEffect(() => {
        fetchData()
    }, [verticalActiveTab])

    const onDelete = id => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this Tender!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, do it!",
            cancelButtonText: "No, cancel!",
        }).then(async willDelete => {
            if (willDelete) {
                setLoading(true)
                const user_id = localStorage.getItem("auth_id")
                try {
                    const response = await axios.delete(
                        `${configure.nodeApi}/tender/${id}/${user_id}`
                    )
                    if (response.data.status === 200) {
                        Swal.fire({
                            icon: "success",
                            title: "Success",
                            text: "Tender Deleted successfully",
                        })
                        fetchData()
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "error",
                            text: response.data.message,
                        })
                    }
                } catch (error) {
                    Swal.fire({
                        icon: "error",
                        title: "error",
                        text: error.message,
                    })
                }
            }
        })
    }


    const columns = useMemo(
        () => BiddingColumns(onDelete),
        []
    )

    return (
        <>
            <div>
                {isLoading && <Loader />}
                <Row className="ms-0 pe-0">
                    <Col lg={12} className="p-0">
                        <Card>
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    refreshData={fetchData}
                                    data={tenderData}
                                    status_options={TenderStatus}
                                    setLoading={setLoading}
                                    sourceId={verticalActiveTab}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Bidding
